import React, { Component } from 'react';
import instance from './axios-instance';
import Systems from './SystemFunction';
import jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginstate: false,
      username: null,
      token: window.localStorage.getItem('token'),
      userid: null,
      missionlist: [],
      loading: true,
      balance: 0,
      rankname: null,
      rankpic: null,
      activeTab: 'daily',   // 'daily' | 'weekly'
    };
  }

  async componentDidMount() {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      try {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
          username: Username,
          userid: decoded.message.member_id,
          loginstate: true,
        });
        await this.loadMissions(Username, token);
      } catch (e) {
        console.log(e);
      }
    } else {
      this.setState({ loading: false });
    }
  }

  loadMissions = async (Username, token) => {
    try {
      await instance.post('/api/v1/getdailymission', {
        userid: Username,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then((res) => {
        if (res.data.status === 200) {
          this.setState({
            missionlist: res.data.message || [],
            loading: false,
          });
        } else {
          this.setState({ missionlist: [], loading: false });
        }
      });
    } catch (e) {
      this.setState({ missionlist: [], loading: false });
    }
  }

  claimMission = async (missionId) => {
    var token = localStorage.getItem('auth_token');
    if (!token) {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'กรุณาเข้าสู่ระบบก่อน', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    try {
      await instance.post('/api/v1/claimdailymission', {
        userid: Username,
        mission_id: missionId,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          await Swal.fire({ title: 'สำเร็จ!', text: 'รับรางวัลเรียบร้อยแล้ว', icon: 'success', confirmButtonText: 'ตกลง' });
          this.loadMissions(Username, token);
        } else if (res.data.status === 201) {
          await Swal.fire({ title: 'แจ้งเตือน', text: 'ภารกิจยังไม่ครบตามเงื่อนไข', icon: 'warning', confirmButtonText: 'ตกลง' });
        } else {
          await Swal.fire({ title: 'ผิดพลาด', text: 'ไม่สามารถรับรางวัลได้', icon: 'error', confirmButtonText: 'ตกลง' });
        }
      });
    } catch (e) {
      await Swal.fire({ title: 'ผิดพลาด', text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', icon: 'error', confirmButtonText: 'ตกลง' });
    }
  }

  renderMobile() {
    const { missionlist, loading, activeTab, loginstate, username } = this.state;

    // ── demo / placeholder missions when API returns empty ──
    const demoMissions = [
      {
        id: 1,
        title: 'เข้าสู่ระบบประจำวัน',
        description: 'เข้าสู่ระบบทุกวันเพื่อรับรางวัล',
        icon: 'login',
        current: 1,
        target: 1,
        reward: 10,
        reward_type: 'เครดิต',
        status: 'completed',   // 'pending' | 'completed' | 'claimed'
        category: 'daily',
      },
      {
        id: 2,
        title: 'ฝากเงินครั้งแรกของวัน',
        description: 'ทำการฝากเงินอย่างน้อย 1 ครั้ง',
        icon: 'deposit',
        current: 0,
        target: 1,
        reward: 50,
        reward_type: 'เครดิต',
        status: 'pending',
        category: 'daily',
      },
      {
        id: 3,
        title: 'เดิมพัน 10 ครั้ง',
        description: 'ทำการเดิมพันให้ครบ 10 ครั้ง',
        icon: 'bet',
        current: 4,
        target: 10,
        reward: 30,
        reward_type: 'เครดิต',
        status: 'pending',
        category: 'daily',
      },
      {
        id: 4,
        title: 'เล่นสล็อต 5 ครั้ง',
        description: 'เล่นเกมสล็อตให้ครบ 5 รอบ',
        icon: 'slot',
        current: 5,
        target: 5,
        reward: 20,
        reward_type: 'เครดิต',
        status: 'completed',
        category: 'daily',
      },
      {
        id: 5,
        title: 'ฝากเงิน 5 วันติดต่อกัน',
        description: 'ฝากเงินติดต่อกันทุกวันให้ครบ 5 วัน',
        icon: 'streak',
        current: 2,
        target: 5,
        reward: 200,
        reward_type: 'เครดิต',
        status: 'pending',
        category: 'weekly',
      },
      {
        id: 6,
        title: 'ยอดเดิมพันสะสมรายสัปดาห์',
        description: 'มียอดเดิมพันสะสม 1,000 บาท ภายใน 1 สัปดาห์',
        icon: 'weekly',
        current: 340,
        target: 1000,
        reward: 500,
        reward_type: 'เครดิต',
        status: 'pending',
        category: 'weekly',
      },
    ];

    const displayList = missionlist.length > 0 ? missionlist : demoMissions;
    const filteredList = displayList.filter(m => m.category === activeTab);

    const getMissionIcon = (type) => {
      switch (type) {
        case 'login':
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-login" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#009bd8" />
                  <stop offset="100%" stopColor="#0066aa" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-login)" />
              <path d="M20 10c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 12c-5.33 0-10 2.67-10 6v1h20v-1c0-3.33-4.67-6-10-6z" fill="#fff" />
            </svg>
          );
        case 'deposit':
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-deposit" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#ff8a00" />
                  <stop offset="100%" stopColor="#ff5500" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-deposit)" />
              <path d="M20 8v16M13 17l7 7 7-7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <rect x="12" y="28" width="16" height="3" rx="1.5" fill="#fff" />
            </svg>
          );
        case 'bet':
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-bet" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#9c27b0" />
                  <stop offset="100%" stopColor="#673ab7" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-bet)" />
              <rect x="10" y="14" width="20" height="12" rx="3" stroke="#fff" strokeWidth="2" fill="none" />
              <circle cx="15" cy="20" r="2" fill="#fff" />
              <circle cx="20" cy="20" r="2" fill="#fff" />
              <circle cx="25" cy="20" r="2" fill="#fff" />
            </svg>
          );
        case 'slot':
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-slot" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#e91e63" />
                  <stop offset="100%" stopColor="#c2185b" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-slot)" />
              <rect x="9" y="13" width="22" height="14" rx="3" stroke="#fff" strokeWidth="2" fill="none" />
              <line x1="16" y1="13" x2="16" y2="27" stroke="#fff" strokeWidth="1.5" />
              <line x1="24" y1="13" x2="24" y2="27" stroke="#fff" strokeWidth="1.5" />
              <path d="M12 20h2M19 20h2M26 20h2" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
            </svg>
          );
        case 'streak':
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-streak" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#ff9800" />
                  <stop offset="100%" stopColor="#f57c00" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-streak)" />
              <path d="M22 9c0 0-8 6-8 11a8 8 0 0016 0c0-3-2-5-3-6-1 3-3 4-5 4 0-3 1-7 0-9z" fill="#fff" />
            </svg>
          );
        case 'weekly':
        default:
          return (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad-weekly" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#4caf50" />
                  <stop offset="100%" stopColor="#2e7d32" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="20" fill="url(#grad-weekly)" />
              <path d="M14 20l4 4 8-8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          );
      }
    };

    const css = `
      /* ══ PAGE ══ */
      .dm-page {
        min-height: 100vh;
        background: #f5f6f8;
        padding-bottom: 90px;
        font-family: 'Prompt', 'Noto Sans Thai', sans-serif;
        max-width: 100vw;
        overflow-x: hidden;
        color: #1a1a1a;
      }

      /* ══ HEADER ══ */
      .dm-header {
        position: sticky;
        top: 0;
        z-index: 150;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        height: 56px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.08);
      }
      .dm-header-left {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
      }
      .dm-back-btn {
        background: none;
        border: none;
        padding: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #1a1a1a;
        flex-shrink: 0;
      }
      .dm-title {
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        color: #1a1a1a;
      }

      /* ══ HERO BANNER ══ */
      .dm-hero {
        background: linear-gradient(135deg, #009bd8 0%, #0066aa 100%);
        padding: 24px 20px 28px;
        text-align: center;
        position: relative;
        overflow: hidden;
      }
      .dm-hero::before {
        content: '';
        position: absolute;
        top: -40px; right: -40px;
        width: 140px; height: 140px;
        background: rgba(255,255,255,0.07);
        border-radius: 50%;
      }
      .dm-hero::after {
        content: '';
        position: absolute;
        bottom: -30px; left: -30px;
        width: 100px; height: 100px;
        background: rgba(255,255,255,0.06);
        border-radius: 50%;
      }
      .dm-hero-icon {
        width: 64px;
        height: 64px;
        margin: 0 auto 12px;
        background: rgba(255,255,255,0.18);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .dm-hero-icon svg {
        width: 36px;
        height: 36px;
      }
      .dm-hero-title {
        margin: 0 0 6px;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
      }
      .dm-hero-sub {
        margin: 0;
        font-size: 13px;
        color: rgba(255,255,255,0.85);
        line-height: 1.5;
      }
      .dm-hero-reset {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        margin-top: 14px;
        background: rgba(255,255,255,0.15);
        border-radius: 20px;
        padding: 5px 14px;
        font-size: 12px;
        color: #fff;
      }
      .dm-hero-reset svg {
        width: 13px; height: 13px;
      }

      /* ══ OVERALL PROGRESS ══ */
      .dm-overall {
        background: #fff;
        margin: 12px 16px;
        border-radius: 14px;
        padding: 16px;
        box-shadow: 0 1px 6px rgba(0,0,0,0.06);
      }
      .dm-overall-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      }
      .dm-overall-label {
        font-size: 13px;
        font-weight: 600;
        color: #374151;
        margin: 0;
      }
      .dm-overall-count {
        font-size: 13px;
        color: #009bd8;
        font-weight: 700;
        margin: 0;
      }
      .dm-overall-bar-wrap {
        height: 8px;
        background: #e5e7eb;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 10px;
      }
      .dm-overall-bar-fill {
        height: 100%;
        background: linear-gradient(90deg, #009bd8, #0066aa);
        border-radius: 4px;
        transition: width 0.4s ease;
      }
      .dm-overall-reward {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #fffbeb;
        border-radius: 10px;
        padding: 10px 12px;
        border: 1px solid #fde68a;
      }
      .dm-overall-reward-icon {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
      }
      .dm-overall-reward-text {
        flex: 1;
        min-width: 0;
      }
      .dm-overall-reward-title {
        font-size: 12px;
        color: #b45309;
        margin: 0 0 2px;
        font-weight: 600;
      }
      .dm-overall-reward-val {
        font-size: 16px;
        font-weight: 700;
        color: #d97706;
        margin: 0;
      }
      .dm-overall-claim-btn {
        background: linear-gradient(135deg, #ff8a00, #ff5500);
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        white-space: nowrap;
        font-family: inherit;
        flex-shrink: 0;
      }
      .dm-overall-claim-btn:disabled {
        background: #d1d5db;
        cursor: not-allowed;
      }

      /* ══ TABS ══ */
      .dm-tabs {
        display: flex;
        margin: 0 16px 12px;
        gap: 8px;
      }
      .dm-tab {
        flex: 1;
        padding: 9px 0;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-family: inherit;
        transition: background 0.15s, color 0.15s;
        background: #e5e7eb;
        color: #6b7280;
      }
      .dm-tab.dm-tab-active {
        background: #009bd8;
        color: #fff;
      }

      /* ══ SECTION LABEL ══ */
      .dm-section-label {
        font-size: 11px;
        font-weight: 600;
        color: #9ca3af;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin: 0 20px 8px;
      }

      /* ══ MISSION CARD ══ */
      .dm-card {
        background: #fff;
        border-radius: 14px;
        margin: 0 16px 10px;
        box-shadow: 0 1px 6px rgba(0,0,0,0.06);
        overflow: hidden;
        border: 1.5px solid transparent;
        transition: border-color 0.2s;
      }
      .dm-card.dm-card-done {
        border-color: #bbf7d0;
      }
      .dm-card.dm-card-claimed {
        border-color: #e5e7eb;
        opacity: 0.75;
      }
      .dm-card-body {
        padding: 14px;
        display: flex;
        align-items: flex-start;
        gap: 12px;
      }
      .dm-card-icon {
        width: 44px;
        height: 44px;
        flex-shrink: 0;
      }
      .dm-card-icon svg {
        width: 44px;
        height: 44px;
        display: block;
      }
      .dm-card-info {
        flex: 1;
        min-width: 0;
      }
      .dm-card-title {
        font-size: 14px;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0 0 3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .dm-card-desc {
        font-size: 12px;
        color: #6b7280;
        margin: 0 0 8px;
        line-height: 1.4;
      }
      .dm-card-progress-wrap {
        height: 6px;
        background: #e5e7eb;
        border-radius: 3px;
        overflow: hidden;
        margin-bottom: 5px;
      }
      .dm-card-progress-fill {
        height: 100%;
        border-radius: 3px;
        transition: width 0.4s ease;
      }
      .dm-card-progress-fill.fill-pending {
        background: linear-gradient(90deg, #009bd8, #0066aa);
      }
      .dm-card-progress-fill.fill-done {
        background: linear-gradient(90deg, #22c55e, #16a34a);
      }
      .dm-card-progress-text {
        font-size: 11px;
        color: #9ca3af;
        margin: 0;
      }
      .dm-card-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 6px;
        flex-shrink: 0;
      }
      .dm-card-reward-badge {
        display: flex;
        align-items: center;
        gap: 4px;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 20px;
        padding: 3px 10px;
        white-space: nowrap;
      }
      .dm-card-reward-badge svg {
        width: 13px;
        height: 13px;
        flex-shrink: 0;
      }
      .dm-card-reward-val {
        font-size: 13px;
        font-weight: 700;
        color: #d97706;
        margin: 0;
      }
      .dm-card-reward-unit {
        font-size: 11px;
        color: #b45309;
        margin: 0;
      }
      .dm-claim-btn {
        background: linear-gradient(135deg, #22c55e, #16a34a);
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 7px 14px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        white-space: nowrap;
        font-family: inherit;
        touch-action: manipulation;
      }
      .dm-claim-btn:disabled,
      .dm-claim-btn.claimed {
        background: #d1d5db;
        color: #9ca3af;
        cursor: not-allowed;
      }
      .dm-claim-btn.pending-btn {
        background: #e5e7eb;
        color: #9ca3af;
        cursor: not-allowed;
      }

      /* ══ STATUS BADGE ══ */
      .dm-status-badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border-radius: 20px;
        padding: 2px 9px;
        font-size: 11px;
        font-weight: 600;
      }
      .dm-status-badge.badge-claimed {
        background: #f3f4f6;
        color: #9ca3af;
      }
      .dm-status-badge.badge-done {
        background: #dcfce7;
        color: #16a34a;
      }
      .dm-status-badge.badge-pending {
        background: #eff6ff;
        color: #3b82f6;
      }

      /* ══ EMPTY STATE ══ */
      .dm-empty {
        text-align: center;
        padding: 48px 20px;
        color: #9ca3af;
      }
      .dm-empty svg {
        width: 64px;
        height: 64px;
        margin: 0 auto 12px;
        display: block;
        opacity: 0.35;
      }
      .dm-empty-title {
        font-size: 15px;
        font-weight: 600;
        margin: 0 0 6px;
        color: #6b7280;
      }
      .dm-empty-sub {
        font-size: 13px;
        margin: 0;
        line-height: 1.5;
      }

      /* ══ LOADING ══ */
      .dm-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        gap: 14px;
        color: #9ca3af;
      }
      .dm-spinner {
        width: 36px;
        height: 36px;
        border: 3px solid #e5e7eb;
        border-top-color: #009bd8;
        border-radius: 50%;
        animation: dm-spin 0.8s linear infinite;
      }
      @keyframes dm-spin {
        to { transform: rotate(360deg); }
      }

      /* ══ FOOTER NOTE ══ */
      .dm-footer-note {
        margin: 0 16px 14px;
        padding: 11px 14px;
        background: #eff6ff;
        border-radius: 10px;
        border-left: 3px solid #009bd8;
        font-size: 12px;
        color: #2563eb;
        line-height: 1.5;
      }
      .dm-footer-note svg {
        width: 13px;
        height: 13px;
        vertical-align: middle;
        margin-right: 4px;
      }
    `;

    const claimedCount = filteredList.filter(m => m.status === 'claimed').length;
    const completedCount = filteredList.filter(m => m.status === 'completed' || m.status === 'claimed').length;
    const totalCount = filteredList.length;
    const allCompletedButUnclaimed = filteredList.every(m => m.status === 'completed' || m.status === 'claimed');
    const overallPct = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

    return (
      <div className="dm-page">
        <style>{css}</style>

        {/* ── Header ── */}
        <header className="dm-header">
          <div className="dm-header-left">
            <button className="dm-back-btn" onClick={() => window.history.back()}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M14 17l-6-6 6-6" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <p className="dm-title">ภารกิจประจำวัน</p>
          </div>
        </header>

        {/* ── Hero Banner ── */}
        <div className="dm-hero">
          <div className="dm-hero-icon">
            <svg viewBox="0 0 36 36" fill="none">
              <path d="M18 4l2.5 7.5H28l-6.5 4.7 2.5 7.5L18 19l-6 4.7 2.5-7.5L9 11.5h7.5L18 4z" fill="#fff" />
            </svg>
          </div>
          <p className="dm-hero-title">ภารกิจประจำวัน</p>
          <p className="dm-hero-sub">
            ทำภารกิจที่กำหนดให้ครบ<br />เพื่อรับรางวัลเครดิตเพิ่มเติม
          </p>
          <div className="dm-hero-reset">
            <svg viewBox="0 0 13 13" fill="none">
              <path d="M11 6.5A4.5 4.5 0 112 6.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M11 2.5v4h-4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            รีเซ็ตทุก 00:00 น.
          </div>
        </div>

        {/* ── Overall Progress ── */}
        <div className="dm-overall">
          <div className="dm-overall-header">
            <p className="dm-overall-label">ความคืบหน้าโดยรวม</p>
            <p className="dm-overall-count">{completedCount}/{totalCount} ภารกิจ</p>
          </div>
          <div className="dm-overall-bar-wrap">
            <div className="dm-overall-bar-fill" style={{ width: `${overallPct}%` }} />
          </div>
          <div className="dm-overall-reward">
            <svg className="dm-overall-reward-icon" viewBox="0 0 32 32" fill="none">
              <defs>
                <linearGradient id="grad-trophy" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#fbbf24" />
                  <stop offset="100%" stopColor="#d97706" />
                </linearGradient>
              </defs>
              <circle cx="16" cy="16" r="16" fill="url(#grad-trophy)" />
              <path d="M16 8l1.8 5.6H24l-4.9 3.5 1.8 5.6L16 19.2l-4.9 3.5 1.8-5.6L8 13.6h6.2L16 8z" fill="#fff" />
            </svg>
            <div className="dm-overall-reward-text">
              <p className="dm-overall-reward-title">โบนัสเมื่อทำครบทุกภารกิจ</p>
              <p className="dm-overall-reward-val">+200 เครดิต</p>
            </div>
            <button
              className="dm-overall-claim-btn"
              disabled={!allCompletedButUnclaimed}
              onClick={() => this.claimMission('overall')}
            >
              รับรางวัล
            </button>
          </div>
        </div>

        {/* ── Tabs ── */}
        <div className="dm-tabs">
          <button
            className={`dm-tab${activeTab === 'daily' ? ' dm-tab-active' : ''}`}
            onClick={() => this.setState({ activeTab: 'daily' })}
          >
            ภารกิจรายวัน
          </button>
          <button
            className={`dm-tab${activeTab === 'weekly' ? ' dm-tab-active' : ''}`}
            onClick={() => this.setState({ activeTab: 'weekly' })}
          >
            ภารกิจรายสัปดาห์
          </button>
        </div>

        {/* ── Mission List ── */}
        {loading ? (
          <div className="dm-loading">
            <div className="dm-spinner" />
            <p style={{ margin: 0, fontSize: 13 }}>กำลังโหลดภารกิจ...</p>
          </div>
        ) : filteredList.length === 0 ? (
          <div className="dm-empty">
            <svg viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="30" stroke="#d1d5db" strokeWidth="2" />
              <path d="M22 32h20M32 22v20" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <p className="dm-empty-title">ไม่มีภารกิจในขณะนี้</p>
            <p className="dm-empty-sub">กลับมาใหม่พรุ่งนี้<br />เพื่อรับภารกิจใหม่</p>
          </div>
        ) : (
          filteredList.map((mission, idx) => {
            const pct = mission.target > 0
              ? Math.min(100, Math.round((mission.current / mission.target) * 100))
              : 0;
            const isDone = mission.status === 'completed';
            const isClaimed = mission.status === 'claimed';

            return (
              <div
                key={mission.id || idx}
                className={`dm-card${isDone ? ' dm-card-done' : ''}${isClaimed ? ' dm-card-claimed' : ''}`}
              >
                <div className="dm-card-body">
                  <div className="dm-card-icon">
                    {getMissionIcon(mission.icon)}
                  </div>
                  <div className="dm-card-info">
                    <p className="dm-card-title">{mission.title}</p>
                    <p className="dm-card-desc">{mission.description}</p>
                    <div className="dm-card-progress-wrap">
                      <div
                        className={`dm-card-progress-fill ${isDone || isClaimed ? 'fill-done' : 'fill-pending'}`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <p className="dm-card-progress-text">
                      {mission.current}/{mission.target} ({pct}%)
                    </p>
                  </div>
                  <div className="dm-card-right">
                    <div className="dm-card-reward-badge">
                      <svg viewBox="0 0 13 13" fill="none">
                        <defs>
                          <linearGradient id="grad-coin-sm" x1="0" y1="0" x2="13" y2="13" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" stopColor="#fbbf24" />
                            <stop offset="100%" stopColor="#d97706" />
                          </linearGradient>
                        </defs>
                        <circle cx="6.5" cy="6.5" r="6.5" fill="url(#grad-coin-sm)" />
                        <text x="6.5" y="9.5" textAnchor="middle" fontSize="7" fontWeight="bold" fill="#fff">฿</text>
                      </svg>
                      <p className="dm-card-reward-val">+{mission.reward}</p>
                      <p className="dm-card-reward-unit">{mission.reward_type || 'เครดิต'}</p>
                    </div>

                    {isClaimed ? (
                      <span className="dm-status-badge badge-claimed">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                          <path d="M2 5l2.5 2.5L8 3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        รับแล้ว
                      </span>
                    ) : isDone ? (
                      <button
                        className="dm-claim-btn"
                        onClick={() => this.claimMission(mission.id)}
                      >
                        รับรางวัล
                      </button>
                    ) : (
                      <button className="dm-claim-btn pending-btn" disabled>
                        {pct}%
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}

        {/* ── Footer Note ── */}
        {!loading && (
          <div className="dm-footer-note">
            <svg viewBox="0 0 13 13" fill="none">
              <circle cx="6.5" cy="6.5" r="6" stroke="#2563eb" strokeWidth="1.2" />
              <path d="M6.5 5.5v4M6.5 4v-.5" stroke="#2563eb" strokeWidth="1.2" strokeLinecap="round" />
            </svg>
            รางวัลจะถูกโอนเข้าบัญชีของท่านทันทีหลังกดรับรางวัล ภารกิจรายวันจะรีเซ็ตทุกวันเวลา 00:00 น. และภารกิจรายสัปดาห์รีเซ็ตทุกวันจันทร์
          </div>
        )}

       
      </div>
    );
  }

  render() {
    return this.renderMobile();
  }
}

export default App;
